// 中文语言包
export default {
  // 通用
  common: {
    confirm: '确认',
    cancel: '取消',
    submit: '提交',
    reset: '重置',
    search: '查询',
    add: '新增',
    edit: '编辑',
    delete: '删除',
    remove: '移除',
    save: '保存',
    close: '关闭',
    back: '返回',
    next: '下一步',
    prev: '上一步',
    loading: '加载中...',
    noData: '暂无数据',
    operation: '操作',
    status: '状态',
    createTime: '创建时间',
    updateTime: '更新时间',
    actions: '操作',
    success: '成功',
    fail: '失败',
    warning: '警告',
    error: '错误',
    tips: '提示',
    pleaseSelect: '请选择',
    pleaseInput: '请输入',
    normal: '正常',
    disabled: '停用'
  },

  // 登录相关
  login: {
    title: '登录',
    personalLogin: '个人登录',
    enterpriseLogin: '企业登录',
    username: '用户名',
    password: '密码',
    phone: '手机号',
    verifyCode: '验证码',
    getVerifyCode: '获取验证码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码',
    loginButton: '登录',
    register: '注册',
    logout: '退出登录'
  },

  // 用户中心
  userCenter: {
    title: '用户中心',
    account: '账号管理',
    message: '消息通知',
    approval: '我的审批',
    identity: '身份认证',
    admin: '企业管理员'
  },

  // 消息相关
  message: {
    title: '消息通知',
    unread: '未读',
    read: '已读',
    starred: '标星',
    all: '全部',
    system: '系统消息',
    business: '业务消息',
    activity: '活动消息',
    noMessage: '暂无消息',
    noMessageDetail: '暂无消息详情',
    markAsRead: '标记为已读',
    markAsUnread: '标记为未读',
    star: '标星',
    unstar: '取消标星',
    delete: '删除消息',
    time: '时间',
    sender: '发送者'
  },

  // 审批相关
  approval: {
    title: '我的审批',
    pending: '待审批',
    approved: '已通过',
    rejected: '已驳回',
    applicant: '申请人',
    approver: '审批人',
    businessType: '业务类型',
    approvalStatus: '审批状态',
    remark: '备注',
    approve: '通过',
    reject: '驳回',
    approvalTime: '审批时间',
    sendApproval: '发送审批',
    approvalResult: '审批结果'
  },

  // 工作台
  workbench: {
    title: '工作台',
    salesman: '业务员管理',
    user: '用户管理',
    addSalesman: '新增业务员',
    salesmanName: '业务员姓名',
    idCard: '身份证',
    phone: '联系电话',
    inviteTime: '邀请时间',
    removeSalesman: '移除业务员',
    confirmRemoveSalesman: '确定要移除业务员"{name}"吗？',
    removeSuccess: '删除成功',
    removeFail: '删除失败，请重试',
    inviteSuccess: '审批申请已发送，等待对方确认',
    inviteFail: '发送审批申请失败，请重试',
    serialNumber: '序号',
    loadListFail: '加载业务员列表失败',
    cannotGetEnterpriseInfo: '无法获取当前企业信息',
    inviteSalesmanRemark: '邀请{name}成为业务员',
    placeholderSalesmanName: '请输入业务员姓名',
    placeholderPhone: '请输入联系电话',
    statusChangeSuccess: '状态修改成功',
    statusChangeFail: '状态修改失败，请重试',
    enable: '启用',
    disable: '禁用',
    confirmStatusChange: '确定要{status}业务员"{name}"吗？'
  },

  // 企业管理员
  enterpriseAdmin: {
    title: '企业管理员',
    addAdmin: '邀请管理员',
    refresh: '刷新',
    adminName: '管理员姓名',
    adminPhone: '管理员手机号',
    adminStatus: '管理员状态',
    adminType: '管理员类型',
    removeAdmin: '移除管理员',
    confirmRemoveAdmin: '确定要移除管理员"{name}"吗？',
    removeSuccess: '移除成功',
    removeFail: '移除失败，请重试',
    statusChangeSuccess: '状态修改成功',
    statusChangeFail: '状态修改失败，请重试'
  },

  // 邀请对话框
  inviteDialog: {
    title: '邀请个人用户',
    inviteeIdCard: '受邀人身份证',
    inviteePhone: '受邀人手机号码',
    inviteeInfo: '受邀人详细信息：',
    refreshQuery: '刷新查询',
    queryAccount: '受邀人账号查询',
    nickname: '昵称',
    realName: '真实姓名',
    idCard: '身份证',
    phone: '手机号',
    verifiedStatus: '实名认证状态',
    isAdmin: '是否为管理员',
    isSalesman: '是否为机构业务员',
    verified: '已认证',
    unverified: '未认证',
    verifying: '认证中',
    rejected: '未通过',
    yes: '是',
    no: '否',
    sendSmsCode: '发送验证码',
    resendSmsCode: '秒后重发',
    verifyCode: '受邀人手机验证码',
    pleaseInputVerifyCode: '请输入受邀人手机验证码',
    confirmInvite: '确认受邀人为业务员',
    confirmInviteAdmin: '确认受邀人为管理员',
    querySuccess: '查询成功',
    queryFail: '查询用户信息失败，请重试',
    notFound: '未找到匹配的用户信息',
    pleaseFillForm: '请填写完整的表单信息',
    pleaseFillIdCardAndPhone: '请先填写身份证号和手机号',
    pleaseQueryFirst: '请先查询受邀人信息'
  },

  // 表单验证
  validation: {
    required: '此项为必填项',
    idCardFormat: '请输入正确的身份证号码',
    phoneFormat: '请输入正确的手机号码',
    emailFormat: '请输入正确的邮箱地址',
    minLength: '长度不能少于{min}个字符',
    maxLength: '长度不能超过{max}个字符'
  }
}

